import {jwtServerInstance} from "../index";
import {getTokenUser} from "@/lib/utils";
import qs from	'qs'

export const queryShareCode = () =>{
    return jwtServerInstance.request({
        url:'/b2csharecode/querysharecode',
        method:'post'
    })
}


export const queryIsOpenShareCode = () =>{
    return jwtServerInstance.request({
        url:'/b2customer/querycisopensharecode',
        method:'post'
    })
}

